import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
jQuery(document).ready(function ($) {
  var ProductDetail = {
    init: function init() {
      this.cache = {
        filterData: {},
        descriptionData: {},
        labels: {},
        galleryImages: {}
      };
      this.form = $('form.variations_form');
      this.productId = this.form.data('product_id');
      this.bindEvents();
      this.prefetchData();
      this.handleSimpleProducts();
      this.generalFunctions();
    },
    bindEvents: function bindEvents() {
      var _this = this;
      $(document).on('found_variation', function (event, variation) {
        _this.updateAllSections(variation, event.target);
      });
      $(document).on('click', '.woocommerce-product-gallery__image.swiper-slide-active', function () {
        $('.xts-photoswipe-btn a').trigger('click');
      });
      $(document).on('click', '.close-products-popup', function () {
        $('.load-articles').addClass('hidden').html('');
      });
      $(document).on('click', '.display-color-popup', function () {
        _this.loadPopupVariations();
      });
    },
    prefetchData: function prefetchData() {
      var _this2 = this;
      if (!this.form.length) return;
      $.get('/wp/wp-admin/admin-ajax.php', {
        action: 'product_variation_images',
        product_id: this.productId
      }).then(function (result) {
        _this2.cache.galleryImages = JSON.parse(result);
        var currentId = $('.variation_id').val();
        if (!isNaN(currentId)) {
          _this2.updateGallery(currentId);
        }
      });
    },
    updateAllSections: function updateAllSections(variation, form) {
      this.updateStock(variation.availability_html, form);
      this.updateUVP(variation.uvp, form);
      this.updateEAN(variation.ean, form);
      this.updateShortDesc(variation.shortdesc);
      this.loadFilterData(variation.variation_id);
      this.loadDescriptionData(variation.variation_id);
      this.loadLabels(variation.variation_id);
      this.updateGallery(variation.variation_id);
    },
    updateStock: function updateStock(html, form) {
      var container = $(form).closest('.summary').find('.stock-copy-into');
      container.html(html).removeClass('hide');
      if (html.includes('yellow')) {
        var shortInfo = container.find('.stock-shortinfo small');
        if (shortInfo.length) {
          container.find('.stock-shortinfo').html(shortInfo.html().replace('Lieferung: ', ''));
        }
      }
    },
    updateUVP: function updateUVP(uvp, form) {
      $(form).closest('.summary').find('.empfohlener-verkaufspreis-uvp .filter-val').html(uvp);
    },
    updateEAN: function updateEAN(ean, form) {
      $(form).closest('.summary').find('.ean .filter-val').html(ean);
    },
    updateShortDesc: function updateShortDesc(shortdesc) {
      $('.woocommerce-product-details__short-description').html(shortdesc);
    },
    loadFilterData: function loadFilterData(variationId) {
      var _this3 = this;
      if (this.cache.filterData[variationId]) {
        $('#tab-product_attributes').html(this.cache.filterData[variationId]);
      } else {
        $.get('/wp/wp-admin/admin-ajax.php', {
          action: 'product_filter_data',
          product_id: variationId
        }).then(function (result) {
          _this3.cache.filterData[variationId] = result;
          $('#tab-product_attributes').html(result);
        });
      }
    },
    loadDescriptionData: function loadDescriptionData(variationId) {
      var _this4 = this;
      if (this.cache.descriptionData[variationId]) {
        $('#tab-additional_information').html(this.cache.descriptionData[variationId]);
      } else {
        $.get('/wp/wp-admin/admin-ajax.php', {
          action: 'product_description_data',
          product_id: variationId
        }).then(function (result) {
          _this4.cache.descriptionData[variationId] = result;
          $('#tab-additional_information').html(result);
        });
      }
    },
    loadLabels: function loadLabels(variationId) {
      var _this5 = this;
      if (this.cache.labels[variationId]) {
        this.replaceLabels(this.cache.labels[variationId]);
      } else {
        $.get('/wp/wp-admin/admin-ajax.php', {
          action: 'load_labels',
          product_id: variationId
        }).then(function (result) {
          _this5.cache.labels[variationId] = result;
          _this5.replaceLabels(result);
        });
      }
    },
    replaceLabels: function replaceLabels(result) {
      var container = $('.load-labels');
      if (result.length !== 0) {
        container.replaceWith(result);
      } else {
        setTimeout(function () {
          return container.html(' ');
        }, 1000);
      }
    },
    updateGallery: function updateGallery(variationId) {
      var html = this.cache.galleryImages[variationId];
      if (!html) return;
      $('.woocommerce-product-gallery').parent().html(html);
      XTSThemeModule.singleProductGallery();
      XTSThemeModule.singleProductGalleryPhotoSwipe();
    },
    loadPopupVariations: function loadPopupVariations() {
      $.get('/wp/wp-admin/admin-ajax.php', {
        action: 'load_all_variations',
        product_id: this.productId
      }).then(function (result) {
        $('.load-articles').html(result).removeClass('hidden');
      });
    },
    handleSimpleProducts: function handleSimpleProducts() {
      if ($('.product-type-simple').length) {
        this.loadLabels($('#simple-product-id').val());
        if ($('.stock-copy-into').length && $('.stock-copy-into').html() !== '') {
          var form = $('.stock-copy-into').closest('.summary').find('form');
          if (!form.length) form = $('.stock-copy-into');
          this.updateStock($('.stock-copy-into').html(), form);
        }
      }
    },
    generalFunctions: function generalFunctions() {
      setTimeout(function () {
        $('#tab-product_attributes, #tab-documents').css('display', 'block');
        ['additional_information', 'product_attributes', 'documents'].forEach(function (tab) {
          if ($("#tab-".concat(tab)).is(':empty')) {
            $("#tab-".concat(tab)).closest('.xts-accordion-item').remove();
          }
        });
      }, 0);
    }
  };
  ProductDetail.init();
});